<template>
	<div class="row dynvibeRow">
		<div class="col-lg-12">
			<div class="dynvibeBox">
				<div class="col-lg-12">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Area Over Time</h2>
					</div>
				</div>
				<div>
					<div v-if="loading" class="dynvibeLoading"></div>
					<div v-if="!loading && noData" class="noData">
						<p>No Data to display</p>
					</div>
					<dynvibechartmore
						ref="chartmore"
						v-if="!loading && !noData && type !== 'stockChart'"
						@download="downloadChart"
					></dynvibechartmore>
					<highcharts
						v-if="!loading && !noData"
						class="highcharts-container"
						ref="chartComponent"
						:options="chartOptions"
					></highcharts>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import dynvibechartmore from "@/components/vueCharts/DynvibeChartMore.vue";
export default {
	name: "dynvibeareastacked",
	props: {
		type: {
			type: String,
			default: "",
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {};
			},
		},
		country: {
			type: Array,
			default: function () {
				return [];
			},
		},
		sources: {
			type: Array,
			default: function () {
				return [];
			},
		},
		age: {
			type: Array,
			default: function () {
				return [];
			},
		},
		gender: {
			type: Array,
			default: function () {
				return [];
			},
		},
		category: {
			type: String,
			default: "",
		},
		subcategory: {
			type: String,
			default: "",
		},
		mastertag: {
			type: String,
			default: "",
		},
		trend: {
			type: String,
			default: "",
		},
		typemastertag: {
			type: String,
			default: "All",
		},
	},
	components: {
		dynvibechartmore: dynvibechartmore,
	},
	data() {
		return {
			loading: true,
			noData: false,
			allseries: {},
			categories: [],
			countries: [
				["FR", "France"],
				["US", "USA"],
				["UK", "United Kingdom"],
				["ES", "Spain"],
			],
			data: {},
			front: false,
			level: "categories",
			chartOptions: {
				chart: {
					type: "area",
				},
				title: {
					text: "",
				},
				xAxis: {
					categories: this.categories,
					tickmarkPlacement: "on",
					title: {
						enabled: false,
					},
				},
				yAxis: {
					gridLineWidth: 0,
					minorGridLineWidth: 0,
					title: {
						text: "Volume",
					},
					labels: {
						formatter: function () {
							return this.value;
						},
					},
				},
				tooltip: {
					split: true,
					valueSuffix: " Posts",
				},
				plotOptions: {
					area: {
						stacking: "normal",
						lineColor: "#666666",
						lineWidth: 1,
						marker: {
							lineWidth: 1,
							lineColor: "#666666",
						},
					},
					series: {
						cursor: "pointer",
						events: {
							click: this.clicked,
						},
					},
				},
				series: this.allseries,
				exporting: {
					enabled: false,
				},
			},
		};
	},
	mounted: function () {
		this.getData("getHistogram", {
			data: {
				type: this.typemastertag,
				level: "categories",
			},
			parameters: {
				panel: this.panel,
				segment: this.segment,
				date: this.date,
				country: this.country,
				category: this.category,
				subcategory: this.subcategory,
				mastertag: this.mastertag,
				trend: this.trend,
				typemastertag: this.typemastertag,
				age: this.age,
				gender: this.gender,
				sources: this.sources,
			},
		});

		this.getChart();
	},

	methods: {
		checkFilters() {
			if (this.date.gte === "") {
				return;
			}
			this.level = "categories";
			if (this.category != "") {
				this.level = "subcategories";
			}
			if (this.subcategory != "" || this.mastertag != "") {
				this.level = "mastertag";
			}
			if (this.trend != "") {
				this.level = "trends";
			}
			this.hidden = false;
			this.loading = true;

			this.getData("getHistogram", {
				data: {
					type: this.typemastertag,
					level: this.level,
				},
				parameters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
					category: this.category,
					subcategory: this.subcategory,
					mastertag: this.mastertag,
					trend: this.trend,
					typemastertag: this.typemastertag,
					age: this.age,
					gender: this.gender,
					sources: this.sources,
				},
			});
		},
		treatResponse(response) {
			this.loading = false;
			this.data = response.data;
			this.noData = this.data.length === 0 ? true : false;
			this.allseries = [];
			this.categories = [];
			let i = 0;

			response.data.forEach((element) => {
				this.allseries.push({
					name: element.key,
					data: element.evolution.buckets.map((x) => {
						this.categories.indexOf(x.key_as_string) == -1 ? this.categories.push(x.key_as_string) : undefined;
						return x.doc_count;
					}),
					color: this.graphColor[i],
				});
				i++;
			});

			this.chartOptions.xAxis.categories = this.categories;
			this.chartOptions.series = this.allseries;
		},
		getChart: function () {},
		clicked(item) {
			let dateAct = this.$moment(item.point.category + "-01").format("YYYY-MM-DD");
			let dateEndOfMonth = this.$moment(dateAct).endOf("month").format("YYYY-MM-DD");
			this.$emit("clicked", {
				keyword: item.point.series.name,
				level: this.level,
				country: "",
				date: {
					gte: dateAct,
					lte: dateEndOfMonth,
				},
			});
		},
		downloadChart(downloadType) {
			if (downloadType === "print") this.$refs.highcharts.chart.print();
			else if (downloadType === "CSV") this.$refs.highcharts.chart.downloadCSV();
			else if (downloadType === "PNG") this.$refs.highcharts.chart.exportChart();
			else if (downloadType === "JPEG") this.$refs.highcharts.chart.exportChart({ type: "image/jpeg" });
			else if (downloadType === "PDF") this.$refs.highcharts.chart.exportChart({ type: "application/pdf" });
			else if (downloadType === "SVG") this.$refs.highcharts.chart.exportChart({ type: "image/svg+xml" });
			else if (downloadType === "XLS") this.$refs.highcharts.chart.downloadXLS();
		},
	},
	watch: {
		panel() {
			this.checkFilters();
		},
		segment() {
			this.checkFilters();
		},
		date: {
			deep: true,
			handler() {
				this.checkFilters();
			},
		},
		country() {
			this.checkFilters();
		},
		category() {
			this.checkFilters();
		},
		subcategory() {
			this.checkFilters();
		},
		mastertag() {
			this.checkFilters();
		},
		trend() {
			this.checkFilters();
		},
		typemastertag() {
			this.checkFilters();
		},
	},
};
</script>
<style scoped>
.highcharts-container {
	overflow: visible !important;
}
</style>
